// date.actions.ts
import { createAction, props } from '@ngrx/store';

export const setSelectedDate = createAction('[Date] Set Selected Date', props<{ selectedDate: Date }>());
export const clearSelectedDate = createAction('[Date] Clear Selected Date');
